import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import InsuranceRepository from '@/repositories/InsuranceRepository';
import { InsurancePolicy } from '@/types/insurancePolicy';

export const useUpdateInsurancePolicy = (
  options?: MutationOptions<
    InsurancePolicy,
    AxiosError,
    { insurancePolicyId: string; values: Partial<InsurancePolicy> }
  >
) => {
  const insuranceRepository = InsuranceRepository();
  const { addMessage } = useContext(AppContext);

  return useMutation({
    mutationFn: ({
      insurancePolicyId,
      values
    }: {
      insurancePolicyId: string;
      values: Partial<InsurancePolicy>;
    }) => insuranceRepository.updateInsurancePolicy(insurancePolicyId, values),
    onSuccess: () => {
      addMessage({ level: 'success', text: 'Insurance Policy updated' });
    },
    ...options
  });
};

export default useUpdateInsurancePolicy;
